import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import {ArticleWrapper} from "./";
import React from "react";
import {HeaderLink} from "BaseComponents/Link";
import {Paragraph} from "BaseComponents/Text";
import {HandleClick} from "Helpers/LinkHelper";
import {getResponsiveImage} from "Helpers/ImageHelper";
import {GetCategoryColor} from "Helpers/ColorHelper";

export const ArticleImage = styled.div.attrs(
  ({Image, isPriorityItem}) => ({})
)`
    flex-basis: ${({isPriorityItem}) =>
            isPriorityItem ? "calc(100% + 2px)" : "50%"};
    width: 100%;
    display: flex;
    align-items: flex-end;
    transition: 0.2s ease;
    height: 100%;
    border-top-left-radius: ${({theme}) => theme.border.radius};
    border-top-right-radius: ${({theme}) => theme.border.radius};
    min-height: 200px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% center;
    background-image: ${({Image}) => `url(${Image})`};
    ${media.lessThan(breakpoints.ipad)`
  `}
    ${media.greaterThan(breakpoints.mobile)`
  	min-height: ${({isPriorityItem}) => (isPriorityItem ? "400px" : "200px")};
  `};
`;
export const DateWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const ArticleBottom = styled.div`
    display: flex;
    flex-direction: column;
    padding: 1rem;
    flex-basis: ${({isPriorityItem}) =>
            isPriorityItem ? "calc(50% - 2px)" : "100%"};
    height: 100%;
`;
export const TextSpan = styled.span`
    font-size: 14px;
    display: flex;
    align-items: center;
`;
export const Square = styled.div`
    display: inline-block;
    width: 9px;
    height: 9px;
    background: ${({beforeColor, theme}) =>
            beforeColor ? beforeColor : theme.colors.secondary};
    margin-right: 5px;
`;

export const Article = (article) => {
  const {
    Url,
    Heading,
    Description,
    ResponsiveImage,
    Date,
    DocumentType,
    isPriority,
    Category,
    CategoryColor,
  } = article;
  let Image = getResponsiveImage(ResponsiveImage);
  let alt = ResponsiveImage.Alt;

  const beforeColor = CategoryColor
    ? `#${CategoryColor}`
    : GetCategoryColor(Category);

  const addImageAttributes = alt && alt.length > 0 ? {role: "img", "aria-label": alt} : {"aria-hidden": "true"};
  return (
    <ArticleWrapper
      isPriorityItem={isPriority}
      onClick={(e) => HandleClick(e, Url)}
    >
      <ArticleImage {...addImageAttributes} isPriorityItem={isPriority} Image={Image}></ArticleImage>
      <ArticleBottom isPriorityItem={isPriority}>
        <DateWrapper>
          <TextSpan>
            <Square/>
            {DocumentType.toUpperCase()}
          </TextSpan>
          {Category && (
            <TextSpan>
              <Square beforeColor={beforeColor}/>
              {Category.toUpperCase()}
            </TextSpan>
          )}
        </DateWrapper>
        <HeaderLink margin="0.5rem 0" text={Heading} size="h3" href={Url}/>
        <Paragraph display="block">{Description}</Paragraph>
      </ArticleBottom>
    </ArticleWrapper>
  );
};
